import React, { createContext, useContext, useState, useEffect } from 'react';
import { getProperties } from '../lib/api';

const PropertyContext = createContext(null);

export const PropertyProvider = ({ children }) => {
  const [properties, setProperties] = useState([]);
  const [selectedPropertyId, setSelectedPropertyId] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProperties();
  }, []);

  const loadProperties = async () => {
    try {
      const res = await getProperties();
      setProperties(res.data);
    } catch (error) {
      console.error('Failed to load properties:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshProperties = async () => {
    await loadProperties();
  };

  const getPropertyName = (propertyId) => {
    if (!propertyId) return 'Unknown';
    const prop = properties.find(p => p.id === propertyId);
    return prop?.name || 'Unknown';
  };

  return (
    <PropertyContext.Provider value={{ 
      properties, 
      selectedPropertyId, 
      setSelectedPropertyId,
      loading,
      refreshProperties,
      getPropertyName
    }}>
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperty = () => {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error('useProperty must be used within a PropertyProvider');
  }
  return context;
};
